export enum UppercaseThemesEnum {
  DEFAULT = 'DEFAULT',
  PROMO1 = 'PROMO1',
  PROMO2 = 'PROMO2',
  EXTRA = 'EXTRA',
  STARS = 'STARS',
  DARK = 'DARK',
  LIGHT = 'LIGHT',
  WHITE = 'WHITE',
  BRAND = 'BRAND'
}

export enum UppercaseBrandThemesEnum {
  DEFAULT = 'DEFAULT',
  EXTRA = 'EXTRA',
  DARK = 'DARK',
  BRAND = 'BRAND',
  BRANDLIGHT = 'BRAND-LIGHT',
  BRANDDARK = 'BRAND-DARK',
  BRANDBASE = 'BRAND-BASE',
  VERY_LIGHT = 'VERY_LIGHT',
  BRAND_LIGHT = 'BRAND_LIGHT',
  BRAND_BASE = 'BRAND_BASE',
  BRAND_DARK = 'BRAND_DARK',
  REGULAR = 'REGULAR',
  COLORED = 'COLORED'
}
